<template>
  <div>
    <el-button
      size="small"
      type="primary"
      icon="el-icon-edit-outline"
      :disabled="disabled"
      @click="visible = true"
    >
      {{ showText ? 'Dịch tự động' : '' }}
    </el-button>
    <translate-popup
      v-if="visible"
      :visible="visible"
      :order="order"
      :total="total"
      :columns="columns"
      :detail="detail"
      :type="type"
      :titles="titles"
      :active-tab="activeTab"
      :children="children"
      @reload="() => $emit('reload')"
      @close="visible = false"
    />
  </div>
</template>

<script>
import TranslatePopup from '../popups/Translate.vue'

export default {
  name: 'TranslateButton',
  components: {
    TranslatePopup
  },
  props: {
    disabled: Boolean,
    order: String,
    total: Number,
    columns: Array,
    type: String,
    titles: Array,
    detail: Object,
    children: Boolean,
    activeTab: [String, Boolean],
    showText: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
